var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('nav-header',{attrs:{"title":_vm.header_title}}),_c('div',{staticClass:"body"},[_c('div',{staticClass:"coursr-desc"},[_c('div',{staticClass:"u-content md-content"},[_c('div',{staticClass:"desc",staticStyle:{"font-size":"16px"},domProps:{"innerHTML":_vm._s(
                    _vm.content.replace(
                        /<img/g,
                        '<img style="width:100%;height:auto;"'
                    )
                    )}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }